import { render } from "./wasteManagementCategory.vue?vue&type=template&id=05d6e1fb"
import script from "./wasteManagementCategory.vue?vue&type=script&lang=js"
export * from "./wasteManagementCategory.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Websites\\Green Earth Marine Project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__